export const elementNames = {
    email: 'email',
    confirmEmail: 'confirmEmail',
    password: 'password',
    passwordStatusCheck: 'passwordStatusCheck',
    termsOfService: 'termsOfService',
    termsOfServiceLink: 'termsOfServiceLink',
    privacyPolicyLink: 'privacyPolicyLink',
    rememberMe: 'rememberMe',
    reviewAndBook: 'reviewAndBook',
};

export const errorNames = {
    emailError: 'emailError',
    emailAlreadyInUseError: 'emailAlreadyInUseError',
    confirmEmailError: 'confirmEmailError',
    passwordError: 'passwordError', // client-side
    serverSideWeakPasswordError: 'serverSideWeakPasswordError',
    submitError: 'submitError',
    termsOfServiceError: 'termsOfServiceError',
};

export const elementMetricNames = {
    [elementNames.email]: 'Email',
    [elementNames.confirmEmail]: 'Confirm email',
    [elementNames.password]: 'Password',
    [elementNames.termsOfService]: 'terms of use & privacy policy',
    [elementNames.termsOfServiceLink]: 'Terms of Use Link',
    [elementNames.privacyPolicyLink]: 'Privacy Policy Link',
    [elementNames.rememberMe]: 'Keep me logged in',
    [elementNames.reviewAndBook]: 'Review & Book button',
};

export const componentNames = {
    [elementNames.email]: 'Email',
    [elementNames.confirmEmail]: 'Confirm email',
    [elementNames.password]: 'Password',
    [elementNames.termsOfService]: 'Terms of Use & Privacy Policy',
    [elementNames.termsOfServiceLink]: 'Terms of Use & Privacy Policy',
    [elementNames.privacyPolicyLink]: 'Terms of Use & Privacy Policy',
    [elementNames.rememberMe]: 'Keep me logged in',
    [elementNames.reviewAndBook]: 'Review & Book button',
    submitError: 'Creation failed try again error',
    signInFailed: 'Signin failed try again error',
    emailAlreadyInUseError: 'Email already in use error',
};

export const EMAIL_TAKEN_MESSAGE = 'That email is already in use.';
